import React from "react";
import { Switch } from "@mui/material";

import Config from "../../../utils/config";
import RequestV2 from "../../../api/RequestV2";

import {
  Card,
  PageLoader,
  SuccessMessage,
  ErrorMessage,
  PageTitle,
  PageBodyTitle
} from "../../design-system";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function CashbackConfigV2() {
  const [loading, setLoading] = React.useState(false);
  const [updating, setUpdating] = React.useState(false);
  const [cashbackEnabled, setCashbackEnabled] =
    React.useState(false);

  const [success, setSuccess] = React.useState("");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    fetchCashbackStatus();
  }, []);

  const fetchCashbackStatus = () => {
    setLoading(true);
    setError("");

    new RequestV2(
      "",
      (res) => {
        const value =
          String(res?.cashbackEnabledValue)
            .trim()
            .toUpperCase() === "TRUE";

        setCashbackEnabled(value);
        setLoading(false);
      },
      (e) => {
        setError(
          e?.message ||
            "Failed to fetch cashback status"
        );

        setLoading(false);
      }
    ).get(Config.apis.admin.GET_CASHBACK_CONFIG);
  };

  const updateCashbackStatus = (value) => {
    setUpdating(true);
    setSuccess("");
    setError("");

    const payload = {
      cashbackEnabledUpdateValue: value
        ? "TRUE"
        : "FALSE",
    };

    new RequestV2(
      "",
      (data) => {
        setCashbackEnabled(value);

        setSuccess(
          data ||
            "Cashback updated successfully"
        );

        setUpdating(false);
      },
      (e) => {
        setError(
          e?.message ||
            "Failed to update cashback status"
        );

        setUpdating(false);
      }
    ).post(
      Config.apis.admin.UPDATE_CASHBACK_CONFIG,
      payload
    );
  };

  if (loading) return <PageLoader />;

  return (
    <>
      <PageBodyTitle>
        Cashback Configuration
      </PageBodyTitle>

      {success && (
        <SuccessMessage
          successMessage={success}
          dataset={String(Date.now())}
        />
      )}

      {error && (
        <ErrorMessage
          error={error}
          datetimestamp={String(Date.now())}
        />
      )}

      <Card
        style={{
          padding: 24,
          marginTop: 16,
          maxWidth: 700,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
          }}
        >
          <div>
           <div
             style={{
               display: "flex",
               alignItems: "center",
               gap: 6,
               fontSize: 16,
               fontWeight: 600,
               marginBottom: 6,
             }}
           >
             Block Cashback
           
             <Tooltip
               title="Changes will be reflected after 1 minute"
               arrow
             >
               <InfoOutlinedIcon
                 style={{
                   fontSize: 18,
                   color: "#6b7280",
                   cursor: "pointer",
                 }}
               />
             </Tooltip>
           </div>
            <div
              style={{
                fontSize: 14,
                color: "#6b7280",
              }}
            >
              Enable/Disable all type of cashback with global switch
            </div>
          </div>

          <Switch
            checked={cashbackEnabled}
            disabled={updating}
            onChange={(e) =>
              updateCashbackStatus(
                e.target.checked
              )
            }
          />
        </div>
      </Card>
    </>
  );
}